import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { FormGroupOf } from '@core/common-legacy';
import { StageCategory } from '@core/stages-types';
import { SelectOption } from '@core/user-interface-legacy';
import {
  AddNoteActionData,
  AddTagsActionData,
  AddTaskActionData,
  AddFollowersActionData,
  AssignActionData,
  RequestEvaluationActionData,
  SendEmailActionData,
  AutomationActionType,
  AutomationTriggerType,
} from '@recruitee/workflow-automations-types';

// Automation form
export type AutomationForm = FormGroup<{
  trigger: FormGroup<{
    type: FormControl<AutomationTriggerType | null>;
    data: FormGroup<{
      stageId?: FormControl<number | null>;
      disqualifyReasonId?: FormControl<number | null>;
    }>;
  }>;
  actions: FormArray;
}>;

// Triggers
export type EmptyTriggerForm = FormGroup<{
  type: FormControl<null>;
  data: FormGroupOf<{}>;
}>;

export type CandidateMovedTriggerForm = FormGroup<{
  type: FormControl<AutomationTriggerType.CandidateMoved>;
  data: FormGroupOf<{
    stageId: number | null;
  }>;
}>;

export type CandidateDisqualifiedTriggerForm = FormGroup<{
  type: FormControl<AutomationTriggerType.CandidateDisqualified>;
  data: FormGroupOf<{
    disqualifyReasonId: number | null;
  }>;
}>;

export type AutomationTriggerForm =
  | EmptyTriggerForm
  | CandidateMovedTriggerForm
  | CandidateDisqualifiedTriggerForm;

export type TriggerDataSelectOption = SelectOption & { stageCategory?: StageCategory };

// Actions
export type AddTagsActionForm = FormGroup<{
  type: FormControl<AutomationActionType.AddTags>;
  data: FormGroupOf<AddTagsActionData>;
}>;
export type AddTaskActionForm = FormGroup<{
  type: FormControl<AutomationActionType.AddTask>;
  data: FormGroupOf<AddTaskActionData>;
}>;
export type AddFollowersActionForm = FormGroup<{
  type: FormControl<AutomationActionType.AddFollowers>;
  data: FormGroupOf<AddFollowersActionData>;
}>;
export type AddNoteActionForm = FormGroup<{
  type: FormControl<AutomationActionType.AddNote>;
  data: FormGroupOf<AddNoteActionData>;
}>;
export type RequestEvaluationActionForm = FormGroup<{
  type: FormControl<AutomationActionType.EvaluationRequest>;
  data: FormGroupOf<RequestEvaluationActionData>;
}>;
export type AssignActionForm = FormGroup<{
  type: FormControl<AutomationActionType.AssignTo>;
  data: FormGroupOf<Pick<AssignActionData, 'offerIds' | 'talentPoolIds'>>;
}>;
export type SendEmailActionForm = FormGroup<{
  type: FormControl<AutomationActionType.SendEmail>;
  data: FormGroupOf<SendEmailActionData>;
}>;

export type AutomationActionForm =
  | AddTagsActionForm
  | AddTaskActionForm
  | AddFollowersActionForm
  | AddNoteActionForm
  | RequestEvaluationActionForm
  | AssignActionForm
  | SendEmailActionForm;

export enum RecipientType {
  Candidate = 'candidate',
  Recruiter = 'recruiter',
  HiringManager = 'hiringManager',
}
